import ActionDialog from '@src/new-components/Dialog/ActionDialog';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { useHistory } from 'react-router-dom';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';
import CrownImg from '@src/assets/images/crown.png';
import CommonButton from '@src/new-components/Button';
import route from '@src/constants/route';
import usePaywallTracking from '@src/hooks/usePaywallTracking';
import {
  MOE_MODULE,
  MOE_PAYWALL_CTA,
  MOE_PAYWALL_TYPE,
} from '@src/constants/moengage';

// `description` (HTML string) overrides the default upsell body, e.g. to name a paywalled model.
// `targetPackageCode` deep-links the CTA to that package instead of the generic pricing page.
// `featureKey` (missing package feature) + `surface` tell the dashboard which gate this was.
const PopupUpPkgUseRewrite = ({
  open,
  onClose,
  pkgName = 'VIP',
  description,
  targetPackageCode,
  featureKey,
  surface,
  product,
}) => {
  const { t } = useTranslation();

  const history = useHistory();

  const { trackCta } = usePaywallTracking({
    paywallType: MOE_PAYWALL_TYPE.PREMIUM_AI,
    module: MOE_MODULE.PROJECT,
    featureKey,
    surface,
    product,
    open,
  });

  const handleUpgrade = () => {
    trackCta(MOE_PAYWALL_CTA.UPGRADE, { targetPackageCode });
    onClose();
    history.push(
      targetPackageCode
        ? `${route.PAYMENT}?package=${targetPackageCode}`
        : route.PAYMENT,
    );
  };

  return (
    <ActionDialog
      open={open}
      title={t('unlockPremiumAIFeaturesNow')}
      styleTitle={{
        textAlign: 'center',
      }}
      contentComponent={
        <Typography
          style={{ textAlign: 'center' }}
          variant="body-16-regular"
          color={COLOR.descriptionGray}
          dangerouslySetInnerHTML={{
            __html:
              description ||
              t('descriptionUnlockPremiumAIFeaturesNow', {
                pkgName,
              }),
          }}
        />
      }
      fullWidth
      image={CrownImg}
      imageContainerSize="100px"
      onClose={onClose}
      width="640px"
      actionComponent={
        <CommonButton
          variant="contained"
          onClick={handleUpgrade}
          textProps={{
            variantText: 'body-14-semibold',
            color: COLOR.darkBlue,
          }}
          customStyle={{
            height: '40px',
            borderRadius: '8px',
            padding: '8px 24px',
            width: '146px',
          }}
        >
          {t('upgradeNow')}
        </CommonButton>
      }
    />
  );
};
export default PopupUpPkgUseRewrite;
